export { default as AddOutlinedIcon } from './add-outlined-icon';
export { default as AkamLogoCheckIcon } from './akam-logo-check-icon';
export { default as AkamLogoTextIcon } from './akam-logo-text-icon';
export { default as AkamProFooterIcon } from './akam-pro-footer-icon';
export { default as AkamProLogoIcon } from './akam-pro-logo-icon';
export * from './app-store-icon'
export { default as ArchiveFilledIcon } from './archive-filled-icon';
export { default as ArchiveIcon } from './archive-icon';
export { default as ArrowDownIcon } from './arrow-down-icon';
export { default as ArrowLeftIcon } from './arrow-left-icon';
export { default as ArrowRightIcon } from './arrow-right-icon';
export { default as ArrowUpRightIcon } from './arrow-up-right-icon';
export { default as AuthDoorIcon } from './auth-door-icon';
export { default as BookSavedIcon } from './book-saved-icon';
export { default as BxlFacebookIcon } from './bxl-facebook-icon';
export { default as BxlTwitterIcon } from './bxl-twitter-icon';
export { default as CalendarFilledIcon } from './calendar-filled-icon';
export { default as CalendarIcon } from './calendar-icon';
export { default as CallIcon } from './call-icon';
export { default as CancelSubjectIcon } from './cancel-subject-icon';
export { default as Candle2Icon } from './candle-2-icon';
export * from './chart-icon'
export { default as CheckCircleIcon } from './check-circle-icon';
export { default as ChevronLeftSmallIcon } from './chevron-left-small-icon';
export { default as ChevronRightSmallIcon } from './chevron-right-small-icon';
export { default as ClickAppIcon } from './click-app-icon';
export { default as ClockIcon } from './clock-icon';
export { default as CloseXIcon } from './close-x-icon';
export * from './document-download-icon'
export { default as DocumentTextIcon } from './document-text-icon';
export { default as DollarCircleIcon } from './dollar-circle-icon';
export { default as EditIcon } from './edit-icon';
export { default as EmptyDataIcon } from './empty-data-icon';
export { default as EmptyHeartIcon } from './empty-heart-icon';
export { default as EyeIcon } from './eye-icon';
export { default as FacebookIcon } from './facebook-icon';
export { default as FireIcon } from './fire-icon';
export { default as GlobalIcon } from './global-icon';
export { default as HamburgerIcon } from './hamburger-icon';
export { default as HeadphoneIcon } from './headphone-icon';
export { default as HeartIcon } from './heart-icon';
export * from './home-icons';
export { default as InfoCircleFilledIcon } from './info-circle-filled-icon';
export { default as InfoCircleIcon } from './info-circle-icon';
export { default as InstagramIcon } from './instagram-icon';
export { default as InstagramOriginalIcon } from './instagram-original-icon';
export { default as InstagramOutlinedIcon } from './instagram-outlined-icon';
export { default as Instagram2Icon } from './instagram2-icon';
export { default as LinkIcon } from './link-icon';
export { default as LinkedinIcon } from './linkedin-icon';
export { default as LocationIcon } from './location-icon';
export { default as LoginIcon } from './login-icon';
export { default as MessageQuestionFilledIcon } from './message-question-filled-icon';
export * from './message-question-header-icon'
export { default as MessageQuestionIcon } from './message-question-icon';
export { default as NoChatHistoryIcon } from './no-chat-history-icon';
export { default as NoteRemoveIcon } from './note-remove-icon';
export { default as PaymeIcon } from './payme-icon';
export { default as PeopleIcon } from './people-icon';
export * from './play-market-icon'
export { default as PresentionChartIcon } from './presention-chart-icon';
export { default as PrivateUniverIcon } from './private-univer-icon';
export { default as ProHeartIcon } from './pro-heart-icon';
export { default as DropDownArchiveIcon } from './profil-dropdown-icons/archive-icon';
export { default as ClipboardCloseIcon } from './profil-dropdown-icons/clipboard-close-icon';
export { default as LogOutIcon } from './profil-dropdown-icons/logout-icon';
export { default as PaypalIcon } from './profil-dropdown-icons/paypal-icon';
export { default as ProfileIcon } from './profil-dropdown-icons/profile-icon';
export { default as TeacherIcon } from './profil-dropdown-icons/teacher-icon';
export { default as RateStarIcon } from './rate-star-icon';
export { default as ReturnBackIcon } from './return-back-icon';
export { default as SearchNormalIcon } from './search-normal-icon';
export * from './second-note-icon'
export { default as Send2Icon } from './send-2-icon';
export { default as Share2Icon } from './share-2-icon';
export { default as ShareIcon } from './share-icon';
export { default as SmsIcon } from './sms-icon';
export { default as StarIcon } from './star-icon';
export { default as SwiperArrowLeftIcon } from './swiper-arrow-left-icon';
export { default as SwiperArrowRightIcon } from './swiper-arrow-right-icon';
export { default as TaskIcon } from './task-icon';
export { default as TaskSquareIcon } from './task-square-icon';
export { default as TelegramCircleIcon } from './telegram-circle-icon';
export { default as TelegramIcon } from './telegram-icon';
export { default as TestEyeIcon } from './test-eye-icon';
export * from './test-start-icon'
export { default as ThunderIcon } from './thunder-icon';
export { default as TickCircleIcon } from './tick-circle-icon';
export { default as TimerIcon } from './timer-icon';
export { default as Twitter } from './twitter-icon';
export { default as UniversityExperienceInfo } from './university-experience-info';
export { default as UniversityGraduatedInfo } from './university-graduated-info';
export { default as UniversityStudentInfo } from './university-student-info';
export { default as UniversityTeacherInfo } from './university-teacher-info';
export { default as UnimetedIcon } from './unlimeted-icon';
export { default as UnlimitedIcon } from './unlimeted-icon';
export { default as VideoPlayIcon } from './video-play-icon';
export { default as WarningIcon } from './warning-icon';
export { default as WhatsappIcon } from './whatsapp-icon';
export { default as YoutubeIcon } from './youtube-icon';
export { default as YoutubeOutlinedIcon } from './youtube-outlined-icon';